module.exports = __webpack_public_path__ + "static/media/top-sign.80d56532.svg";